type TReportVioaltionProps = {
  setOpenViolationModal: React.Dispatch<React.SetStateAction<boolean>>;
};
const ReportViolation = ({setOpenViolationModal}: TReportVioaltionProps) => {
  return (
    <>
      <div
        className="flex mt-3 mb-7"
        onClick={() => setOpenViolationModal(true)}
      >
        <span className="text-error icon-warning ml-2 mt-1"></span>
        <p className=" text-gray-6">گزارش تخلف</p>
      </div>
    </>
  );
};

export default ReportViolation;
